export default "/_next/static/images/30215fdcbf234c8c8e0dd8c8ce5d9648.svg";